import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, TextField,
} from "@mui/material";
import { useEffect, useState } from "react";

/**
 * Notatka do decyzji.
 *
 * Przy zatwierdzeniu opcjonalna, przy odrzuceniu wymagana — odrzucenie bez
 * powodu zmusza autora do zgadywania, co poprawić, i wraca do akceptanta
 * w tej samej postaci. Serwer sprawdza to samo; tu chodzi o to, żeby nie
 * odsyłać użytkownika po komunikat z drugiego końca.
 */
export function DecisionDialog({
  open, tryb, tytul, opis, onClose, onConfirm, blad, pracuje,
}: {
  open: boolean;
  tryb: "approve" | "reject";
  tytul: string;
  opis?: string;
  onClose: () => void;
  onConfirm: (comment: string) => void;
  blad?: string;
  pracuje?: boolean;
}) {
  const [notatka, setNotatka] = useState("");
  const odrzucenie = tryb === "reject";
  const pusta = !notatka.trim();

  useEffect(() => {
    if (open) setNotatka("");
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{tytul}</DialogTitle>
      <DialogContent>
        {opis && <DialogContentText sx={{ mb: 2 }}>{opis}</DialogContentText>}
        {blad && <Alert severity="error" sx={{ mb: 2 }}>{blad}</Alert>}
        <TextField
          autoFocus fullWidth multiline minRows={3} value={notatka}
          label={odrzucenie ? "Uzasadnienie (wymagane)" : "Notatka (opcjonalna)"}
          error={odrzucenie && pusta && Boolean(blad)}
          helperText={odrzucenie
            ? "Napisz, co trzeba poprawić — bez tego autor będzie zgadywał."
            : "Zostanie zapisana w historii decyzji."}
          onChange={(e) => setNotatka(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Anuluj</Button>
        <Button
          variant="contained"
          color={odrzucenie ? "error" : "primary"}
          disabled={pracuje || (odrzucenie && pusta)}
          onClick={() => onConfirm(notatka.trim())}
        >
          {odrzucenie ? "Odrzuć" : "Zatwierdź"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
